import React, { Component, useState, useEffect } from 'react';
import './password-strength-meter.css';
import zxcvbn from 'zxcvbn';
import { useTranslation } from 'react-i18next/';
import { Lock } from '@mui/icons-material';

export const PasswordStrengthBar = ({ password }) => {
    const { t, i18n } = useTranslation();
    const testedResult = zxcvbn(password);

    const createPasswordLabel = (result) => {
        if (result) {
            switch (result.score) {
                case 0:
                    return t('PasswordStrength.Levels.Weak');
                case 1:
                    return t('PasswordStrength.Levels.Weak');
                case 2:
                    return t('PasswordStrength.Levels.Fair');
                case 3:
                    return t('PasswordStrength.Levels.Good');
                case 4:
                    return t('PasswordStrength.Levels.Strong');
                default:
                    return t('Weak');
            }
        }
    };

    return (
        <div className="password-strength-meter">
            <progress
                // className={`password-strength-meter-progress strength-${createPasswordLabel(
                //   testedResult
                // )}`}
                className={`password-strength-meter-progress strength-${testedResult.score}`}
                value={testedResult.score}
                max="4"
            />

            <br />
            <label className={`password-strength-meter-label-${testedResult.score}`}>
                {password && (
                    <>
                        <strong className="password-strength-label">
                            {t('PasswordStrength')}: {createPasswordLabel(testedResult)}
                            <Lock sx={{ fontSize: '22px', marginBottom: 0.5, marginLeft: 1 }} />{' '}
                        </strong>
                    </>
                )}
            </label>
        </div>
    );
};

// https://upmostly.com/tutorials/build-a-password-strength-meter-react
